import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import * as dayjs from 'dayjs';

interface JobCellParams extends ICellRendererParams {
  showEndDate: boolean;
  oneColLayout?: boolean;
}

@Component({
    selector: 'app-job-cell',
    template: `
  <div class="job-cell-container" [class.one-col-layout]="oneColLayout">
    <div class="job-cell tw-text-base tw-py-2"
    [ngClass]="{'tw-flex tw-flex-col tw-gap-2': oneColLayout}">
      <div class="left-column tw-pt-1 tw-gap-2">
        <div class="title tw-flex tw-items-center tw-gap-2 tw-font-semibold tw-text-gray-600 dark:tw-text-gray-300">
        <mat-icon
          class="title-icon tw-text-gray-500 dark:tw-text-gray-500 tw-flex-shrink-0 tw-text-[20px] tw-h-[20px] tw-w-[20px]">
          work_outline
        </mat-icon>
        {{ title }}
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <div class="company tw-text-sm" [title]="company">{{ company }}</div>
        <div *ngIf="oneColLayout" class="date tw-text-gray-500 dark:tw-text-gray-400">{{ date }}</div>
      </div>
      
      </div>
      <div class="right-column">
        <div *ngIf="!oneColLayout" class="date tw-text-gray-500 dark:tw-text-gray-400">{{ date }}</div>
        <div *ngIf="level || function" class="tags">
          <span class="tag tw-bg-gray-200 dark:tw-bg-gray-600">{{ level }}</span>
          <span class="tag tw-bg-gray-200 dark:tw-bg-gray-600">{{ function }}</span>
        </div>
      </div>
    </div>
  </div>
  `,
    styles: [
        `
    .job-cell-container {
      container-type: inline-size;
      .job-cell {
        padding: 4px 2px 2px 2px;
        height: 100%;

        .left-column {
          display: flex;
          flex-direction: column;
          justify-content: center;

          .title-icon {
            display: none;
          }
        }
        .right-column {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .date {
          font-size: 12px;
        }
        .title {
          line-height: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .company {
          margin-bottom: 2px;
          line-height: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .tags {
          display: flex;
          gap: 4px;
          margin-bottom: 4px;
        }
        .tag {
          font-size: 12px;
          padding: 2px 4px;
          border-radius: 4px;
          line-height: normal;
        }
      }
    }

    @container (min-width: 241px) {
      .job-cell-container .job-cell .left-column .title-icon {
        display: block;
      }
    }

    @container (min-width: 300px) {
      .job-cell-container:not(.one-col-layout) .job-cell {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
      }
      .job-cell-container:not(.one-col-layout) .right-column {
        align-items: flex-end;
      }
    }
  `,
    ],
    standalone: false
})
export class JobCellComponent {
  private job: any;
  private showEndDate: boolean;
  oneColLayout: boolean = false;

  agInit(params: JobCellParams): void {
    this.job = params.value;
    this.showEndDate = params.showEndDate;
    this.oneColLayout = params.oneColLayout ?? false;
  }

  refresh(params: JobCellParams): boolean {
    this.agInit(params);
    return true;
  }

  get title(): string {
    return this.job?.title || '';
  }

  get company(): string {
    return this.job?.company?.name || '';
  }

  get level(): string {
    return this.job?.level || '';
  }

  get function(): string {
    return this.job?.function || '';
  }

  get date(): string {
    if (!this.job?.started_at) return '';

    const tString = this.job?.ended_at
      ? 'YYYY'
      : this.job?.metadata?.started_at_year_only
        ? 'YYYY'
        : 'YYYY-MM';
    const startDate = dayjs(this.job.started_at).utc().format(tString);

    if (this.job?.ended_at) {
      return `${startDate} → ${dayjs(this.job.ended_at).utc().format(tString)}`;
    } else {
      return startDate;
    }

    return startDate;
  }
}
